import generateUUID from "includes/UUID";

export default function custom_charts_displayer(chart) {
	let values = chart.parsedChartValues();
	let Cols = [];
	let Rows = [];

	for (let x = 0; x < 2; x++)
	{
		let id = x + "-" + generateUUID();
		Cols.push({
			colId: id,
			title: id,
			name: "col-" + id,
			type: "col"
		});
	}

	values.forEach((value, index) => {
		let id = index + "-" + generateUUID();
		let row = {
			rowId: id,
			type: "row",
			color: value.color
		};
		Cols.forEach((col, y) => {
			if (y > 0)
				col.value = value.label;
			if (y === 0)
				row[col.name] = value.label;
			else
				row[col.name] = value.value;
		});
		Rows.push(row);
	});

	return ({
		Cols,
		Rows
	});
}
